import _ from 'underscore'
import Vue from 'vue'
import Subject from '../../resources/subject'

// This is an object where subjects will be stored
// with keys as the id, and chapter as the value
const state = {}

const getters = {
  allSubjects(state) {
    return _.values(state);
  }
}

const actions = {
  getSubjects(context) {
    console.log('Fetching subjects...')
    Subject.query({}).then((res) => {
      context.commit(`RETRIEVE_SUBJECTS_SUCCESS`, {subjects: res.data})
    }, (res) => {
      Toast.error('Failed to retrieve subjects')
    })
  },

  createSubject(context, payload) {
    Subject.save(payload.subject).then((res) => {
      context.commit(`CREATE_SUBJECT_SUCCESS`, { subject: res.data });
      if (payload && _.isFunction(payload.callback)) payload.callback(null, res.data);
    }, (res) => {
      Toast.error('Failed to create subject')
    })
  },

  deleteSubject(context, payload) {
    Subject.delete({id: payload.subject.id}).then((res) => {
      context.commit(`DELETE_SUBJECT_SUCCESS`, {subject: payload.subject});
    }, (res) => {
      Toast.error('Failed to delete subject')
    })
  },

  // payload.id, payload.changes
  updateSubject(context, payload) {
    Subject.update({id: payload.id}, payload.changes).then((res) => {
      context.commit(`UPDATE_SUBJECT_SUCCESS`, {subject: res.data});
    }, (res) => {
      Toast.error('Failed to save subject')
    })
  },
}

const mutations = {
  LOGOUT_SUCCESS() {
    // Clear state
    for(let prop in state) Vue.delete(state, prop)
  },

  RETRIEVE_SUBJECTS_SUCCESS(state, payload) {
    // #todo - We may want to completely clear the state at this point
    _.each(payload.subjects, (subject) => {
      Vue.set(state, subject.id, subject);
    })
  },

  CREATE_SUBJECT_SUCCESS(state, payload) {
    // console.log(`CREATE_SUBJECT_SUCCESS`, payload.subject)
    Vue.set(state, payload.subject.id, payload.subject);
  },

  DELETE_SUBJECT_SUCCESS(state, payload) {
    Vue.delete(state, payload.subject.id);
  },

  // payload.subject
  UPDATE_SUBJECT_SUCCESS(state, payload) {
    Vue.set(state, payload.subject.id, payload.subject);
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/subjects.js